import z from "zod";

/**
 * PesquisaSatisfacaoItemSchema
 */

export const PesquisaSatisfacaoItemSchema = z.object({
  ordem: z.string({ required_error: 'Este campo deve ser preenchido!' }).min(1, "Este campo deve ser preenchido!"),
  descricao: z.string({ required_error: 'Este campo deve ser preenchido!' }).min(1, "Este campo deve ser preenchido!"),
});

/**
 * PesquisaSatisfacaoItemForm
 */

export type PesquisaSatisfacaoItemForm = z.infer<typeof PesquisaSatisfacaoItemSchema>;

